import {
  Backdrop,
  CircularProgress,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ReconcilationList from "./components/reconcilationList";
import { useEffect, useState } from "react";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ExcelJS from "exceljs";
import MDTypography from "components/MDTypography";
import { Download } from "@mui/icons-material";
import TLinkApi from "services/tlink.api";

function GlobalReconciliation() {
  const [reconcilations, setReconciliations] = useState([]);
  const [loading, setLoading] = useState(false);
  let { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  let { primary } = colors;
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortBy, setSortBy] = useState("id");
  const [search, setSearch] = useState("");

  const GetReconcilationList = async () => {
    setLoading(true);
    try {
      let data = await TLinkApi.get(
        `/global/reconciliation/title/list?search=${search}&sortOrder=${sortOrder}&sortBy=${sortBy}`
      );
      if (Array.isArray(data?.data)) setReconciliations(data.data);
      setLoading(false);
    } catch (e) {
      console.log(e);
      enqueueSnackbar(e?.response?.data?.message||"", {
        variant: "error",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    GetReconcilationList();
  }, [search, sortBy, sortOrder]);

  return (
    <div style={{ marginRight: "0.4rem" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        pb={1}
        sx={{ borderBottom: `2px solid ${primary.main}`, width: "100%" }}
        mb={2}
      >
        <MDTypography fontSize="22px" color="black">
          Global Reconciliation
        </MDTypography>
        <Stack direction="row" spacing={2}>
          <Tooltip title="Sample Global Reconciliation File" arrow={false} placement="top">
            <MDButton
              size="small"
              variant="contained"
              color="secondary"
              sx={{ alignItems: "center" }}
              startIcon={<Download />}
              onClick={async () => {
                const tokens = [
                  "22e8728645234140abff54fbbd7632f9",
                  "609405b5e4b548109bc7fb004c8be675",
                ];
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("Sheet1");
                tokens.forEach((token) => {
                  worksheet.addRow([token]);
                });
                const blob = await workbook.xlsx.writeBuffer();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(new Blob([blob]));
                link.download = "SampleFile.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <Typography sx={{ fontSize: "13px" }}> Sample.</Typography>
              <Typography
                sx={{ textTransform: "lowercase !important", fontSize: "13px" }}
              >
                xlsx
              </Typography>
            </MDButton>
          </Tooltip>
          {location.pathname !== "/globalReconciliation/new" ? (
            <Tooltip title="Add New Global Reconcilaition" arrow={false}  placement="top">
              <MDButton
                variant="contained"
                size="small"
                color="info"
                onClick={() => {
                  navigate("new");
                }}
              >
                + New
              </MDButton>
            </Tooltip>
          ) : (
            ""
          )}
        </Stack>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={3}>
          <ReconcilationList
            reconcilations={reconcilations}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            setSearch={setSearch}
          />
        </Grid>
        <Grid item xs={9}>
          <MDBox
            style={{
              height: "calc(100vh - 140px)",
              overflowY: "auto",
              background: "white",
              paddingInline: "1rem",
              borderRadius:"0.5rem"
            }}
          >
            {location.pathname === "/globalReconciliation" ? (
              <MDBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={4}
                textAlign="center"
                fontSize="13px"
                fontWeight="500"
              >
                Please select a reconcilation to view its
                <br /> content here or create a new one
              </MDBox>
            ) : (
              <Outlet
                context={{
                  GetReconcilationList,
                }}
              />
            )}
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}

export default GlobalReconciliation;
